module.exports = __webpack_public_path__ + "img/fly-talks.222a2ca7.svg";